import React from 'react';
import { Background, Navbar } from 'layout';
import { Image } from 'ui';
import Card from 'react-bootstrap/Card';
import styles from './NotFound.module.css';
import PropTypes from 'prop-types';

const NotFound = (props) => {
    return (
        <>
            <Navbar />
            <Background className={styles.notFoundWrapper}>
                <Card.Body className={styles.body}>
                    <Image className={styles.image} name={props.image || 'page-not-found.svg'} />
                    <br />
                    <h5>{props.heading || 'Page not found or this device not supported.'}</h5>
                </Card.Body>
                {props.children}
            </Background>
        </>
    );
};

NotFound.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    children: PropTypes.node,
};

export default NotFound;
